"use client";

import { useTranslations } from "next-intl";
import { css, cx } from "styled-system/css";
import { stack } from "styled-system/patterns";

import { AnnouncementCategory, useAnnouncements } from "@/contexts/queries/announcements";

import { AnnouncementCard } from "./components/announcement-card";

interface AnnouncementsContentProps {
  category: AnnouncementCategory | null;
}

export function AnnouncementsContent({ category }: AnnouncementsContentProps) {
  const t = useTranslations("announcements");
  const { data } = useAnnouncements({ category });

  return (
    <div className={cx(stack({ gap: "0", flex: "1", w: "full" }), "group")}>
      {data.items.map((announcement, index) => (
        <AnnouncementCard key={announcement.id} announcement={announcement} isFirst={index === 0} />
      ))}

      {data.items.length === 0 && (
        <div
          className={css({
            textStyle: "body.lg",
            color: "text.tertiary",
            textAlign: "center",
            py: "48",
          })}
        >
          {t("noAnnouncements")}
        </div>
      )}
    </div>
  );
}
